module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eUIRD"))).then(() => parcelRequire('d0iPb'));